/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IModulo from 'Infotrack@Modelos/administracion/modulo/entidades/modulo';
import React from 'react';
import ModuloCM from '../controladorModelo/moduloCM';
import { acciones, IEstadoModulo } from '../reductorModulo';
import FormularioModuloVista from '../vista/formularioModuloVista';

const estadoInicial: IModulo = {
    NombreModulo: '',
};
const moduloCM = new ModuloCM();

const FormularioModuloCV: React.FunctionComponent = () => {
    const [{ estadoFormulario, tipoFormulario, entidadModulo }, dispatch] = useProveedor<IEstadoModulo>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IModulo>(estadoInicial);

    React.useEffect(() => {
        if (entidadModulo && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadModulo);
        } else {
            reiniciar();
        }
    }, [entidadModulo]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionModulo = () => {
        if (moduloCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarModulo,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarModulo = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            moduloCM.crearModulo(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        } else {
            moduloCM.editarModulo(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        }
    };

    return (
        <FormularioModuloVista
            accionCrearEditar={confirmarCreacionEdicionModulo}
            cambiarInfoFomulario={alCambiarValor}
            modulo={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

export default FormularioModuloCV;
